<div class="main-content">
    <div class="storelocatoe-wrap">
        <div class="container">
            <div class="breadcrumbs">
                <a routerLink="/">Home</a>
                <img loading="lazy" class="mx-3" [src]="environment?.blobUrl+'/assets/icons/chevron-right.svg'" alt="Home | Luminous">
                <a routerLink="/store-locator" (click)="utils.reloadPage()">Store Locator</a>
            </div>
            <h1>Store Locator</h1>
        </div>
        <div class="banner">
            <picture>
                <source media="(max-width:768px)" srcset="{{environment?.blobUrl}}/assets/images/store-locator/store-locator-mob-banner.webp">
                <img loading="lazy" [src]="environment?.blobUrl+'/assets/images/store-locator/store-locator-banner.webp'" alt="Store Locator | Luminous">
            </picture>
        </div>
        <div class="form">
            <div class="container">
                <div class="company-form">
                    <form action="" class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-5">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Enter pincode or city</mat-label>
                                        <input matInput type="text" [(ngModel)]="searchText" autocomplete="off"
                                            name="searchText" class="cst-form-control ">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-5 mb-5 mb-md-0">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Product Category</mat-label>
                                        <mat-select [(ngModel)]="category" [ngModelOptions]="{standalone: true}">
                                            <mat-option *ngFor="let category of categoryList"
                                                [value]="category?.categoryName">
                                                {{category?.categoryName}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2 text-center text-md-start">
                                    <input type="button" value="Search" class="primaryBtn"
                                        (click)="getServiceLocator('new')">
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="store-location">
            <div class="container" *ngIf="serviceLocatorList?.length">
                <h3 *ngIf="searchText && foundText">{{totalCount}} stores found near {{searchText}}</h3>
                <div class="location" *ngFor="let store of serviceLocatorList ">
                    <h3>{{store?.storeName}}</h3>
                    <div class="d-flex justify-content-between">
                        <p>{{store?.address}}</p>
                        <a class="ms-5" href="tel:{{store?.mobile}}"><img  loading="lazy" [src]="environment?.blobUrl+'/assets/images/contact-us/phone.svg'"
                                alt="Phone | Luminous"></a>
                    </div>
                    <!-- <a target="_blank"
                        href="http://maps.google.com/?q={{store?.storeName}} {{store?.address}}"><u>View on
                            Map</u></a> -->
                </div>
                <div class="text-center store-btn">
                    <a *ngIf="serviceLocatorList.length<totalCount" (click)="getServiceLocator('more')"
                        class="grey-btn arrow text-start">Load More</a>
                </div>
            </div>
            <div class="container" *ngIf="!serviceLocatorList?.length && storeLocatorResponse">
                <h3>No Store found</h3>
            </div>
        </div>
    </div>
</div>
